@import 'tailwindcss';
@import '@dfds-frontend/navigator-components/styles';
@import '@dfds-pax/shared-components/date-field/styles';

@source '../node_modules/@dfds-frontend/navigator-icons/';
@source '../node_modules/@dfds-pax/shared-components/dist/';

@font-face {
  font-family: 'DFDS Sans';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('/fonts/DFDSSans-Light.woff2') format('woff2');
}

@font-face {
  font-family: 'DFDS Sans';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/DFDSSans-Regular.woff2') format('woff2');
}

@font-face {
  font-family: 'DFDS Sans';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/DFDSSans-Italic.woff2') format('woff2');
}

@font-face {
  font-family: 'DFDS Sans';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('/fonts/DFDSSans-Medium.woff2') format('woff2');
}

@font-face {
  font-family: 'DFDS Sans';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/fonts/DFDSSans-Bold.woff2') format('woff2');
}

@font-face {
  font-family: 'DFDS Sans';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url('/fonts/DFDSSans-Extrabold.woff2') format('woff2');
}

@layer base {
  body {
    font-family: 'DFDS Sans', sans-serif;
  }
}

/*
 * Old dotcom (Gatsby) only. That host ships unlayered global element resets
 * (`button, input, select, textarea { background-color: transparent; color: inherit }`,
 * `a { color: #49a2df }`, `ul li { margin-bottom: 15px }`, ...). Unlayered CSS always wins
 * over layered CSS regardless of specificity, so those resets beat everything Tailwind
 * emits inside `@layer base` / `@layer utilities`. `revert-layer` rolls each property back
 * to the value our own layers produced.
 */
#travel-search-dotcom-container :where(#travel-search-root *) {
  all: revert-layer;
}

/* Old dotcom (Gatsby) pages mount the widget flush against the grid edges below `lg`. */
@media (width < 1024px) {
  #travel-search-dotcom-container #travel-search {
    padding: 20px;
  }
}

@utility typography-heading-2xl {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-34 leading-primitive-40 tracking-primitive-0 align-middle md:text-primitive-40 md:leading-primitive-48 lg:text-primitive-48 lg:leading-primitive-56;
}

@utility typography-heading-xl {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-28 leading-primitive-32 tracking-primitive-0 align-middle md:text-primitive-34 md:leading-primitive-40 lg:text-primitive-40 lg:leading-primitive-48;
}

@utility typography-heading-lg {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-24 leading-primitive-28 tracking-primitive-0 align-middle md:text-primitive-28 md:leading-primitive-32 lg:text-primitive-34 lg:leading-primitive-40;
}

@utility typography-heading-md {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-20 leading-primitive-24 tracking-primitive-1 md:text-primitive-24 md:leading-primitive-28 lg:text-primitive-26 lg:leading-primitive-32;
}

@utility typography-heading-sm {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-18 leading-primitive-20 tracking-primitive-1 md:text-primitive-20 md:leading-primitive-24 lg:text-primitive-20 lg:leading-primitive-24;
}

@utility typography-body-md-regular {
  @apply font-primitive-dfds-sans font-primitive-regular text-primitive-16 leading-primitive-24 tracking-primitive-0 align-middle;
}

@utility typography-body-md-regular {
  @apply font-primitive-dfds-sans font-primitive-regular text-primitive-16 leading-primitive-24 tracking-primitive-0 align-middle;
}

@utility typography-body-md-medium {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-16 leading-primitive-24 tracking-primitive-0 align-middle;
}

@utility typography-body-sm-medium {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-14 leading-primitive-20 tracking-primitive-0 align-middle;
}

@utility typography-body-sm-regular {
  @apply font-primitive-dfds-sans font-primitive-regular text-primitive-14 leading-primitive-20 tracking-primitive-0 align-middle;
}

@utility typography-body-xs-regular {
  @apply font-primitive-dfds-sans font-primitive-regular text-primitive-12 leading-primitive-16 tracking-primitive-1 align-middle;
}

@utility typography-body-xs-medium {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-12 leading-primitive-16 tracking-primitive-1 align-middle;
}

@utility typography-number-lg {
  @apply font-primitive-dfds-sans font-primitive-bold text-primitive-28 leading-primitive-32 tracking-primitive-0 md:text-primitive-34 md:leading-primitive-40 lg:text-primitive-40 lg:leading-primitive-48;
}

@utility typography-number-md {
  @apply font-primitive-dfds-sans font-primitive-bold text-primitive-24 leading-primitive-32 tracking-primitive-0 md:text-primitive-28 md:leading-primitive-32 lg:text-primitive-34 lg:leading-primitive-40;
}

@utility typography-number-sm {
  @apply font-primitive-dfds-sans font-primitive-bold text-primitive-20 leading-primitive-24 tracking-primitive-0 md:text-primitive-24 md:leading-primitive-32 lg:text-primitive-28 lg:leading-primitive-32;
}

@utility typography-body-lg-regular {
  @apply font-primitive-dfds-sans font-primitive-regular text-primitive-20 leading-primitive-32 tracking-primitive-0 align-middle;
}

@utility typography-body-lg-medium {
  @apply font-primitive-dfds-sans font-primitive-medium text-primitive-20 leading-primitive-32 tracking-primitive-0 align-middle;
}